import { create } from 'zustand';

interface FirstLoginState {
  userId: string | null;
  email: string | null;
  needsResendOnReturn: boolean;
  setFirstLoginUser: (data: { userId: string; email?: string | null }) => void;
  setNeedsResendOnReturn: (value: boolean) => void;
  clearFirstLoginUser: () => void;
}

export const STORAGE_KEY_USER_ID = 'riloma_fl_userId';
export const STORAGE_KEY_EMAIL = 'riloma_fl_email';
export const STORAGE_KEY_NEEDS_RESEND = 'riloma_fl_needs_resend';
export const STORAGE_KEY_COOLDOWN_UNTIL = 'riloma_fl_cooldown_until';

function readInitial(): {
  userId: string | null;
  email: string | null;
  needsResendOnReturn: boolean;
} {
  if (typeof window === 'undefined')
    return { userId: null, email: null, needsResendOnReturn: false };
  try {
    const userId = sessionStorage.getItem(STORAGE_KEY_USER_ID);
    const email = sessionStorage.getItem(STORAGE_KEY_EMAIL);
    const needsResend = sessionStorage.getItem(STORAGE_KEY_NEEDS_RESEND) === 'true';
    return { userId: userId ?? null, email: email ?? null, needsResendOnReturn: needsResend };
  } catch {
    return { userId: null, email: null, needsResendOnReturn: false };
  }
}

export const useFirstLoginStore = create<FirstLoginState>((set) => {
  const initial = readInitial();
  return {
    userId: initial.userId,
    email: initial.email,
    needsResendOnReturn: initial.needsResendOnReturn,
    setFirstLoginUser: ({ userId, email }) => {
      try {
        sessionStorage.setItem(STORAGE_KEY_USER_ID, userId);
        if (email) {
          sessionStorage.setItem(STORAGE_KEY_EMAIL, email);
        } else {
          sessionStorage.removeItem(STORAGE_KEY_EMAIL);
        }
        if (!sessionStorage.getItem(STORAGE_KEY_COOLDOWN_UNTIL)) {
          sessionStorage.setItem(STORAGE_KEY_COOLDOWN_UNTIL, String(Date.now() + 60 * 1000));
        }
      } catch {
        /* storage unavailable */
      }
      set({ userId, email: email ?? null });
    },
    setNeedsResendOnReturn: (value: boolean) => {
      try {
        if (value) {
          sessionStorage.setItem(STORAGE_KEY_NEEDS_RESEND, 'true');
        } else {
          sessionStorage.removeItem(STORAGE_KEY_NEEDS_RESEND);
        }
      } catch {
        /* storage unavailable */
      }
      set({ needsResendOnReturn: value });
    },
    clearFirstLoginUser: () => {
      try {
        sessionStorage.removeItem(STORAGE_KEY_USER_ID);
        sessionStorage.removeItem(STORAGE_KEY_EMAIL);
        sessionStorage.removeItem(STORAGE_KEY_NEEDS_RESEND);
        sessionStorage.removeItem(STORAGE_KEY_COOLDOWN_UNTIL);
      } catch {
        /* storage unavailable */
      }
      set({ userId: null, email: null, needsResendOnReturn: false });
    },
  };
});
